export default {
    // demo
    hello: '欢迎来到英雄联盟！',
    signIn: '登录',
    // 页签
    tagsView: {
        closeCurrent: '关闭当前',
        closeOther: '关闭其他',
        closeAll: '关闭所有',
    },
    // 登录页
    login: {
        loginByPhone: '手机号登录',
        loginByPassword: '密码登录',
    },
    header: {
        homePage: '首页',
        product: '产品',
        marketManage: '营销管理',
        shoppingMall: '商城',
        saleManagement: '销售管理',
        customerService: '客户服务',
        customers: '客户管理',
        brandManage: '品牌管理',
        lxtEmpowerment: '路行通赋能',
        businessData: '经营数据',
    },
    sideBar: {
        accountSetting: '账号设置',
        editPassword: '修改密码',
        editPhone: '修改手机号',
        logOut: '退出登录',
    },
    button: {
        cancel: '取消',
        confirm: '确定',
        confirmForbidden: '确认禁用',
        confirmActive: '确认启用',
        search: '查询',
        detail: '详情',
        edit: '编辑',
        delete: '删除',
        forbidden: '禁用',
        active: '启用',
    },
    msg: {
        deleteSuccess: '删除成功',
        editSuccess: '编辑成功',
        addSuccess: '新增成功',
        operateSuccess: '操作成功',
    },
    // 公共搜索计数组件
    resultCount: {
        resultTotal: '满足条件的搜索结果',
        company: '条',
    },
    footor: {
        statement: 'Copyright © 1999-2020 成都路行通信息技术有限公司版权所有',
        record: '蜀ICP备08110633号-2',
        license: '增值电信业务经营许可证：川B2-20130092',
    },
};
